import React from "react";
import { useFormContext, get } from "react-hook-form";
import { FormattedMessage } from "react-intl";

function InputField({
  label,
  field_id,
  placeholder,
  required,
  validations,
  type = "text",
  onKeyPress,
  labelClassName,
}: any) {
  const {
    register,
    formState: { errors },
  } = useFormContext();

  return (
    <div>
      <div>
        {label && (
          <label htmlFor={field_id} className={`${required ? "required" : ""} ${labelClassName}`}>
            {label}
          </label>
        )}
        <input
          type={type}
          className={`form-control font-b3 pt-10 pb-10 pl-14 pr-14 bg-white w-100 height-auto placeholder-light ${
            get(errors, field_id) ? "border-danger" : ""
          }`}
          placeholder={placeholder}
          {...register(field_id, { required, ...validations })}
          onKeyPress={onKeyPress}
        />
        {get(errors, field_id) && (
          <div className="d-block font-b3 invalid-feedback text-wrap">
            {get(errors, field_id)?.message ? (
              get(errors, field_id).message
            ) : (
              <FormattedMessage id="general.requiredField" defaultMessage="This is a required field" />
            )}
          </div>
        )}
      </div>
    </div>
  );
}

export default InputField;
